/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backbone from 'backbone';

import ErrorView from '@/views/ErrorView/ErrorView';
import Scaffold from '@/Scaffold';
import { userHasRole } from '@/util/RoleUtils';

import GetAllInternalUserTypes from '../services/GetAllInternalUserTypes';
import SelfServiceView from '../views/SelfServiceView';

export default async function loadSelfServiceView() {
  if (!userHasRole('Admin')) {
    showErrorView({ message: 'Unauthorized' });
    return;
  }

  try {
    const [roles] = await Promise.all([
      GetAllInternalUserTypes()
    ]);
    
    return new SelfServiceView({
      model: new Backbone.Model({
        roles
      })
    });
  } catch (err) {
    showErrorView(err);
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'An Error Occurred'
      })
    })
  );
}
